import React from 'react';

export const MainContainer: React.FC<React.PropsWithChildren> = ({
  children,
}) => <div className="tw-w-full-space tw-max-w-[40rem]">{children}</div>;
